import React, { Dispatch, SetStateAction } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { SelectProps } from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import { StyledGrid } from "components/simple";
import { StyledSelect, StyledInputLabel } from "./styled";

interface CustomProps {
  callback?: Dispatch<string | number>;
  defaultText: string;
  disabled?: boolean;
  options: OptionObj[];
  valuesArr: OptionObj[];
  setValuesArr: Dispatch<SetStateAction<{ id: string; name: string }[]>>;
  limit?: number;
}

export interface OptionObj {
  id: string;
  name: string;
}

type DropdownProps = CustomProps & SelectProps;

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    right: 10
  }
}));

const DropdownMultipleSearch: React.FC<DropdownProps> = ({
  callback,
  defaultText,
  disabled,
  options,
  valuesArr,
  setValuesArr,
  limit,
  ...otherProps
}: DropdownProps) => {
  const [displayData, setDisplayData] = React.useState<string[]>([]);
  const classes = useStyles();

  const handleChange = (clickedValue: string) => {
    const clickedID = clickedValue[clickedValue.length - 1];
    const isInState = valuesArr.filter(x => x.id === clickedID);
    const newValue = options.find(x => x.id === clickedID);
    if (limit) {
      if (limit > isInState.length || limit === isInState.length) {
        return;
      }
    }
    if (isInState.length > 0) {
      setValuesArr(valuesArr.filter(x => x.id !== clickedID));
      setDisplayData(displayData.filter(x => x !== newValue?.name));
    } else {
      if (newValue) {
        setValuesArr([...valuesArr, newValue]);
        setDisplayData([...displayData, newValue.name]);
      }
    }
  };

  return (
    <StyledGrid container width="100%">
      <StyledGrid item xs={12}>
        <FormControl fullWidth>
          <StyledInputLabel id="multiple-checkbox-label">{defaultText}</StyledInputLabel>
          <StyledSelect
            IconComponent={ArrowDropDownIcon}
            id="multiple-checkbox"
            multiple
            value={displayData}
            onChange={e => handleChange(e.target.value as string)}
            input={<Input />}
            renderValue={selected => (selected as string[]).join(", ")}
            classes={{ icon: classes.icon }}
          >
            {options.map(option => (
              <MenuItem key={option.id} value={option.id}>
                <Checkbox checked={valuesArr.filter(x => x.id === option.id).length > 0} />
                <ListItemText primary={option.name} />
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>
      </StyledGrid>
    </StyledGrid>
  );
};

export default DropdownMultipleSearch;
